import authService from '@/services/zybook-auth-service';
import { redirect, type LoaderFunctionArgs } from 'react-router';

export function requireAuth({ request }: LoaderFunctionArgs) {
    if (!authService.isAuthenticated()) {
        const url = new URL(request.url);
        const redirectTo = url.pathname + url.search;
        return redirect(`/login?redirectTo=${encodeURIComponent(redirectTo)}`);
    }

    // Limited accounts: books + public demos only; block review and sandbox tools.
    if (!authService.canSeeAllMAContent()) {
        const url = new URL(request.url);
        const pathname = url.pathname;
        const reviewMatch = pathname.match(/^\/books\/([^/]+)\/([^/]+)\/*$/i);
        if (reviewMatch) {
            let sectionName: string;
            try {
                sectionName = decodeURIComponent(reviewMatch[2]);
            } catch {
                return redirect('/books');
            }
            if (sectionName.toLowerCase() === 'review') {
                return redirect(`/books/${reviewMatch[1]}`);
            }
        }
        const allowedPrefixes = ['/demo', '/books'];
        const disallowedPaths = ['/demo/converter', '/demo/batch-diff', '/demo/document-compare'];
        const isDisallowedPath = disallowedPaths.some(path => pathname.startsWith(path));
        const isAllowedPath = allowedPrefixes.some(path => pathname === path || pathname.startsWith(`${path}/`));
        if (isDisallowedPath || !isAllowedPath) {
            return redirect('/books');
        }
    }

    return null;
}
